import React from 'react';
import { TextField } from '@mui/material';
import { useAppSelector, useAppDispatch } from '../../../../../app/store';
import { updateCheckInfoAction as updateCheckInfo } from '../../../../../services/RefundService/slice';

export const AddressLine1Field: React.FC = () => {
    const dispatch = useAppDispatch();
    const { currentRefund } = useAppSelector(state => state.refund);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        dispatch(updateCheckInfo({ streetAddress1: event.target.value }));
    };

    return (
        <TextField
            label="Address Line 1"
            value={currentRefund?.checkInfo?.streetAddress1 || ''}
            onChange={handleChange}
            size="small"
            sx={{ flex: 2 }}
        />
    );
};

export default AddressLine1Field;
